<template>
  <div
    class="publish-upload-field"
    :class="[
      `publish-upload-field--${variant}`,
      {
        'publish-upload-field--title-hidden': !showTitle,
        'publish-upload-field--trigger-first': triggerFirst,
      },
    ]"
  >
    <div v-if="showTitle" class="publish-upload-field__header">
      <PublishTitle level="field">{{ title }}</PublishTitle>
      <PublishTitle v-if="meta" level="assist">{{ meta }}</PublishTitle>
    </div>
    <div class="publish-upload-field__content">
      <slot />
    </div>
  </div>
</template>

<script>
import PublishTitle from "./PublishTitle.vue";

export default {
  name: "PublishUploadField",
  components: { PublishTitle },
  props: {
    title: {
      type: String,
      required: true,
    },
    meta: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "image",
      validator: (value) => ["image", "file"].includes(value),
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    triggerFirst: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
@import "./tokens.less";

.publish-upload-field {
  position: relative;
  padding: 12px @publish-space-card-x 14px;
}

.publish-upload-field__header {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 4px 8px;

  /deep/ .publish-title {
    max-width: 100%;
    min-width: 0;
    white-space: normal;
    word-break: normal;
    overflow-wrap: normal;
  }
}

.publish-upload-field__content {
  margin-top: 8px;
}

.publish-upload-field--title-hidden {
  .publish-upload-field__content {
    margin-top: 0;
  }
}

.publish-upload-field--trigger-first {
  /deep/ .upload-wrapper {
    justify-content: flex-start;
  }

  /deep/ .upload-trigger {
    order: -1;
    flex-shrink: 0;
  }
}

.publish-upload-field /deep/ .upload-title {
  display: none;
}

.publish-upload-field /deep/ .upload-voucher-section,
.publish-upload-field /deep/ .oss-upload-container {
  margin: 0;
  padding: 0;
  background: transparent;
  border-radius: 0;
}

.publish-upload-field /deep/ .upload-container,
.publish-upload-field /deep/ .upload-wrapper {
  flex-wrap: nowrap;
  gap: 6px;
  padding: 0 !important;
  overflow-x: auto;
  overflow-y: hidden;
  background: transparent;
  border: 0;
  border-radius: 0;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.publish-upload-field /deep/ .upload-container::-webkit-scrollbar,
.publish-upload-field /deep/ .upload-wrapper::-webkit-scrollbar {
  display: none;
}

.publish-upload-field /deep/ .upload-voucher-section .upload-btn.square,
.publish-upload-field /deep/ .upload-voucher-section .preview-item.square,
.publish-upload-field /deep/ .upload-trigger,
.publish-upload-field /deep/ .file-item,
.publish-upload-field /deep/ .file-preview {
  width: 76px;
  height: 76px;
  box-sizing: border-box;
  flex: 0 0 76px;
  border-radius: 7px;
}

.publish-upload-field /deep/ .upload-voucher-section .upload-btn.square,
.publish-upload-field /deep/ .upload-trigger {
  color: @publish-text-secondary;
  background: #f8fafc;
  border: 1px dashed @publish-placeholder;
}

.publish-upload-field /deep/ .upload-voucher-section .upload-btn.square .van-icon,
.publish-upload-field /deep/ .upload-trigger .van-icon {
  color: @publish-text-secondary;
  font-size: 24px;
}

.publish-upload-field /deep/ .upload-voucher-section .upload-btn.square span,
.publish-upload-field /deep/ .upload-trigger span {
  width: 100%;
  box-sizing: border-box;
  padding: 0 4px;
  margin-top: 4px;
  text-align: center;
  white-space: normal;
  word-break: normal;
  overflow-wrap: normal;
  line-height: 15px;
  color: @publish-text-secondary;
  font-size: 12px;
}

.publish-upload-field /deep/ .upload-voucher-section .upload-btn.square:active,
.publish-upload-field /deep/ .upload-trigger:active {
  background: #f2f3f5;
}
</style>
